/** The `proposalErrors` area: the refusals of proposals and their changes (src/domain/proposals.ts, src/server/proposals.ts), as descriptors a surface formats
 *  (docs/I18N.md §6). The English is the refusal's `message`, unchanged. */
export const proposalErrors = {
  'proposalErrors.path.unknownModule': 'Unknown module in field path "{path}".',
  'proposalErrors.path.missingField': 'Missing field in path "{path}".',
  'proposalErrors.path.notPlannable': '"{path}" is not a plannable field.',
  'proposalErrors.path.collection': '"{path}" is a collection and cannot be staged.',
  'proposalErrors.value.priority': 'priority must be must, should, or could.',
  'proposalErrors.proposal.ownerOnly': 'Only the proposal owner can change it.',
  'proposalErrors.proposal.frozen':
    'A published proposal is frozen; stage changes in a new proposal (addendum).',
  'proposalErrors.proposal.nothingStaged': 'Nothing to publish: stage at least one change first.',
  'proposalErrors.proposal.nothingToPublish': 'Nothing to publish.',
  'proposalErrors.change.notFound': 'Change not found.',
  'proposalErrors.change.resolved': 'This change is already resolved.',
  'proposalErrors.change.notPublished': "Only a published proposal's changes can be applied.",
  'proposalErrors.ask.noOwner':
    'Nobody holds the owner seat here, so there is nobody to ask; nothing was done.',
  'proposalErrors.ask.expired': 'This ask expired; it was declined and nothing was done.',
  'proposalErrors.ask.noAct': 'This ask carries no act.',
  'proposalErrors.ask.ownerOnly': 'Only the owner of this item can answer this ask.',
  'proposalErrors.plan.noOrg': 'You are not a member of any org.',
  'proposalErrors.plan.personalSelf': 'A personal plan can only be created for yourself.',
  'proposalErrors.plan.notFound': 'Plan not found.',
  'proposalErrors.plan.closedToProposals': 'A published plan no longer takes proposals.',
  'proposalErrors.plan.closedToChanges':
    'A published plan no longer takes changes; start a new plan.',
  'proposalErrors.plan.memberOnly': 'You must belong to the plan to contribute to it.',
  'proposalErrors.plan.otherOrg': 'Proposal and plan are in different orgs.',
  'proposalErrors.plan.alreadyPublished': 'Plan is already published.',
  'proposalErrors.plan.ownerOnly': 'Only the plan owner can publish it.',
  'proposalErrors.plan.nothingToPublish':
    'Nothing to publish: the plan has no proposals with changes.',
  /** {verb}: the phrase common.error.orgMemberOnly / groupMemberOnly takes. */
  'proposalErrors.verb.createPlan': 'create a plan',
  'proposalErrors.verb.plan': 'plan',
} as const;
